import RightArrowIcon from '@/CustomIcons/RightArrowIcon'
import RadioCircleIcon from '@/CustomIcons/RadioCircleIcon'
import { IconCircle } from '@/components/CircleIcon'
import { Button } from '@/UIComponents2/Button'
import DotsMenuIcon from '@/CustomIcons/DotsMenuIcon'
import { DashboardRoom } from '@/AppContext'
import { useHistory } from 'react-router-dom'
import { DateTime } from 'luxon'
import { cn } from '@/utlis/cn'
import { frontpageReloadTrigger } from './useFrontpage'
import Api from '@/services/Api'
import { SimpleMenu } from '@/UIComponents2/SimpleMenu'
import { BalloonText } from '@/components/BalloonText'
import { useState } from 'react'
import { copyToClipboard } from '@/utils'
import { useTranslation } from 'react-i18next'

type DashRoomCardProps = {
    className?: string
    room: DashboardRoom
    permanent?: boolean
    active?: boolean
}
export function DashRoomCard({ className, room, permanent, active }: DashRoomCardProps) {
    const history = useHistory()

    const border = 'border-muse-toplit-low rounded-[26px]'
    const bg = 'bg-[rgba(255,255,255,0.03)]'
    const layout = 'flex flex-col p-3 gap-5'
    return (
        <div className={cn('group', border, bg, layout, className)}>
            <div className="flex justify-between items-center">
                <div className="flex gap-6 items-center">
                    <div>
                        <IconCircle className="relative w-[40px] h-[40px]">
                            <RadioCircleIcon className={cn(active && 'text-[#85E0A3]')} style={{ fontSize: '20px' }} />
                        </IconCircle>
                    </div>
                    <div>
                        <div className="flex flex-col justify-around">
                            <span className="t-base">{room.name}</span>
                            <span className="t-sm-light opacity-50">{room.host?.username ?? ''}</span>
                            <div className="t-sm-light opacity-50">
                                Active {DateTime.fromISO(room.updatedAt ?? '').toRelative()}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    {permanent && <Menu roomUrn={room._id ?? ''} joinLink={room.joinLink} />}
                    <Button
                        variant={active ? 'glow' : 'secondary'}
                        className="py-0 px-0 w-[48px] h-[40px]"
                        onClick={() => {
                            history.push(`/join/${room?.joinCode}`)
                        }}
                    >
                        <RightArrowIcon />
                    </Button>
                </div>
            </div>
        </div>
    )
}

function Menu({ roomUrn, joinLink }: { roomUrn: string; joinLink: string }) {
    const { t } = useTranslation()

    const handleDeleteRoom = async () => {
        await Api.deleteRoom(roomUrn)
        frontpageReloadTrigger.trigger()
    }

    const [copied, setCopied] = useState(false)
    const handleCopy = () => {
        copyToClipboard(joinLink)
        setCopied(true)
        setTimeout(() => {
            setCopied(false)
        }, 700)
    }

    const items = [
        { label: t('Delete Room'), onClick: handleDeleteRoom },
        {
            label: (
                <div className="relative overflow-visible">
                    {t('Copy Session Link')}
                    <BalloonText active={copied} text={t('Copied!')} />
                </div>
            ),
            onClick: handleCopy,
            closeOnSelect: false,
        },
    ]

    return (
        <SimpleMenu items={items}>
            <Button className="py-1 px-1 opacity-70">
                <DotsMenuIcon style={{ fontSize: '1.3rem' }} />
            </Button>
        </SimpleMenu>
    )
}
